import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type TContainer = {
  children: ReactNode;
  className?: string;
  as?: React.ElementType;
};

export const Container = (props: TContainer) => {
  const { as: Cmp = 'div', className = '', ...rest } = props;

  return <Cmp className={twMerge('px-4 max-w-screen-2xl xl:mx-auto', className)} {...rest} />;
};
